export const renderTextWithLine = (content, dashIfNull = false) => {
    if (content !== null && content !== undefined && typeof content === 'string') {
        const lines = content.split('\n');

        // viac vs 1 riadkove
        if (lines.length > 1) {
            return lines.map((line, index) => (
                line.length > 0 ?
                    <div key={index}>{line}</div>
                    :
                    <p/>
            ));
        } else {
            return <span>{content}</span>
        }

    } else if (content !== null && content !== undefined && typeof content === 'number') {
        return content
    } else return null;
};